import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import BackgroundAnimation from '../../components/motion/atoms/BackgroundAnimation';
import OwnProductsContent from '../../components/service/organisms/OwnProductsContent';

/**
 * 自社商品ページ
 * @returns 
 */
function OwnProducts() {
  const links = [{link:'/ownProducts', pageName:textData['menu.service.ownProducts']['ja']}];
  const titleText = textData['menu.service.ownProducts']['ja'];
  return (

    <div>
      <BackgroundAnimation />
      <Seo title={titleText} description={seoData.pages.ownProducts.description} path='/ownProducts' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <OwnProductsContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default OwnProducts;
